import { FC } from 'react';
import style from './style.module.scss';

interface Props {
	text: string;
}

export const MiniTitle: FC<Props> = ({ text }) => {
	return <h3 className={style.title}>{text}</h3>;
};
